// extracted by mini-css-extract-plugin
export default {"container":"UploadFileControl_container__bdgk+","error":"UploadFileControl_error__+xHQg"};